import { get, post } from "@Lib/request";
import { path, host } from "./url";
import * as ts from "@Types/api";
import getUUID from "@Lib/uuid";

const { dc, www } = host;
const { newCarApiV1, newCarApiV2, newCarApiV3, usedCarApiV4, usedCarApi, newCarApiV4, usedApi } = path;

//

export function fetchKindsPcRecommendKinds(params?: any): Promise<ts.Response<ts.IKindsPcRecommendKinds>> {
  return get(`${newCarApiV3}/kinds/pc/recommend/kinds`, params);
}

export function fetchNewCarBrands(params?: any) {
  return get<any>(`${newCarApiV2}/brand/select`, { type: "base", ...params });
}

export function fetchNewCarKinds(params?: any) {
  return get<any>(`${newCarApiV2}/kind/select`, params);
}

export function fetchUsedCarBrands(params?: any) {
  return get<any>(`${usedCarApi}/newIndex/brands`, params);
}

export function fetchUsedCarKinds(params?: { b: number }) {
  return get<any>(`${usedCarApi}/newIndex/kinds`, params);
}

export function fetchNewIndexRegion() {
  return get<any>(`${usedCarApi}/newIndex/region`);
}

export function fetchNewCarHomeMovie(params?: { type: string }) {
  return get<any>(`${newCarApiV2}/home/movie`, { ...params });
}

export function fetchNewcarHot(params?: any) {
  return get<any>(`${newCarApiV2}/brand/recommend`, params);
}

export function fetchNewcarSelect(params?: any) {
  return get<any>(`${newCarApiV2}/home/filter/menu`, params);
}

export function fetchUsedcarHot() {
  return get<any>(`${usedCarApi}/newIndex/recommendBrand`);
}

export function fetchUsedcarSelect() {
  return get<any>(`${usedCarApi}/newIndex/filterMenu`);
}

export function fetchNewcarPano() {
  return get<any>(`${newCarApiV2}/pano/rank`);
}

export function fetchHomeHotNewcar() {
  return get<any>(`${newCarApiV2}/home/hot/newcar`);
}

export function fetchHomeSelected() {
  return get<any>(`${usedCarApi}/newIndex/topDealerItem`);
}

export function fetchHomeAudi() {
  return get<any>(`${usedCarApi}/newIndex/singleOrgItems?domain=audi`);
}
export function fetchNewIndexHotCar() {
  return get<any>(`${usedCarApi}/newIndex/hotCar`);
}

export function fetchHomeUsedcarOther(params: { type: number }) {
  return get<any>(`${usedCarApi}/newIndex/orgItems`, params);
}

export function fetchHomeUsedcarShops() {
  return get<any>(`${usedCarApi}/newIndex/shopAd`);
}

export function fetchFocusList() {
  return get<any>(`${newCarApiV2}/focus/list`);
}

export function fetchSellRank(params?: { limit: number }) {
  return get<any>(`${newCarApiV2}/hotsell`, { f: " latest-month", ...params });
}

export function fetchCompare(params?: any) {
  return get<any>(`${newCarApiV2}/home/compare`, params);
}

export function fetchFocusSlide() {
  return get<any>(`${newCarApiV2}/focus/banner`);
}

export function subscriberData() {
  return get<any>(`${newCarApiV1}/movie/pc/subscriberData`);
}

export function fetchGeneric(params: { es_tag: string; [key: string]: string }) {
  return get<any>(`${dc}/collect`, { ...params });
}

export function fetchNewDealed(params?: { limit?: number }) {
  return get<any>(`${usedCarApiV4}/sell/newDealed`, { limit: 20, ...params });
}

export function fetchUsedCarStatistics() {
  return get<any>(`${usedCarApiV4}/common/item/statics`);
}

// export function fetchHomeHotAd() {
//   return get<any>(`${www}/indexapi-autoAd.html`, { limit: 10 })
// }
export function fetchHomeHotAd() {
  return get<any>(`${usedCarApiV4}/exposure/extra/exposure/list`, { limit: 10, deviceId: getUUID() });
  // return get<any>('http://127.0.0.1:4523/mock/356799/api/v4/exposure/extra/exposure/list', { limit: 10, deviceId: getUUID() })
}

export async function articleCategories(params: { page?: number; limit?: number; showArticle?: number }) {
  return get<any>(`${newCarApiV3}/article/categories`, params);
}

export async function collect(id, type, position) {
  return await get(`${newCarApiV3}/collect`, { id, type, position });
}

// 活動詳情
export async function fetchActiveInfo(params) {
  return await get(`${newCarApiV2}/active/info`, params);
}

export function fetchHomeNewItem(params) {
  return get<any>(`${usedCarApiV4}/home/itemShow`, params);
}

// 油价
export async function fetchOilPrice(params?: any) {
  return await get(`${newCarApiV3}/oil/price`, params);
}

// 大家都在看
export async function fetchKindsRecommends(params?: any) {
  return await get(`${newCarApiV3}/kinds/recommends`, params);
}

// 配備詳解 - nav
export async function fetchEquipsNav(params?: any) {
  return await get(`${newCarApiV4}/equip/movie/pc/home/nav`, params);
}

// 配備詳解 - list
export async function fetchEquipsList(params?: any) {
  return await get(`${newCarApiV4}/equip/movie/list`, params);
}

// 首页影音-文章list
export function fetchHomeMovieAndArticle(params?: { type: string }) {
  return get<any>(`${newCarApiV4}/main-home-contents`, { ...params });
}

// 廣告招商數據提交API
export async function adsApply(params) {
  return await post(`${usedApi}/ads/apply`, params);
}
